import api from "../../../api.js";
import {
  MED_SEARCH_REQUEST,
  MED_SEARCH_SUCCESS,
  MED_SEARCH_FAIL,
  LOWSTOCK_REQUEST,
  LOWSTOCK_SUCCESS,
  LOWSTOCK_FAIL,
  SALE_REQUEST,
  SALE_SUCCESS,
  SALE_FAIL,
  PRESCRIPTION_REQUEST, // ✅ NEW
  PRESCRIPTION_SUCCESS, // ✅ NEW
  PRESCRIPTION_FAIL, // ✅ NEW
} from "../../constants/pharmacistConstants/pharmacistConstants";

export const searchMedicines = (q) => async (dispatch) => {
  dispatch({ type: MED_SEARCH_REQUEST });
  try {
    const { data } = await api.get(
      `/pharmacist/search?q=${encodeURIComponent(q)}`
    );
    dispatch({ type: MED_SEARCH_SUCCESS, payload: data });
  } catch (err) {
    dispatch({
      type: MED_SEARCH_FAIL,
      payload: err.response?.data?.msg || err.message,
    });
    throw err;
  }
};

export const fetchLowStock = () => async (dispatch) => {
  dispatch({ type: LOWSTOCK_REQUEST });
  try {
    const { data } = await api.get("/pharmacist/lowstock");
    dispatch({ type: LOWSTOCK_SUCCESS, payload: data });
  } catch (err) {
    dispatch({
      type: LOWSTOCK_FAIL,
      payload: err.response?.data?.msg || err.message,
    });
  }
};

export const createSale = (payload) => async (dispatch) => {
  dispatch({ type: SALE_REQUEST });
  try {
    const { data } = await api.post("/pharmacist/createsale", payload);
    dispatch({ type: SALE_SUCCESS, payload: data.sale });
    return { ok: true, sale: data.sale, msg: data.msg };
  } catch (err) {
    dispatch({
      type: SALE_FAIL,
      payload: err.response?.data?.msg || err.message,
    });
    return { ok: false, error: err.response?.data?.msg || err.message };
  }
};

export const fetchPrescriptionByMRCode = (mrCode) => async (dispatch) => {
  dispatch({ type: PRESCRIPTION_REQUEST });
  try {
    const { data } = await api.get(`/pharmacist/prescription/${mrCode}`);
    dispatch({ type: PRESCRIPTION_SUCCESS, payload: data });
    return { ok: true, data };
  } catch (err) {
    dispatch({
      type: PRESCRIPTION_FAIL,
      payload: err.response?.data?.msg || err.message,
    });
    return { 
      ok: false, 
      error: err.response?.data?.msg || err.message,
      found: false 
    };
  }
};